import React from 'react';

import {WeaPortalLayout} from 'weaPortalPublic';
import objectAssign from "object-assign";

export default class PortalLayout extends React.Component{
    render() {
        const {location = {},params={}} = this.props;
        const {query = {}} = location;
        const requestParmas = objectAssign({},params,query)
        const {id, isSetting, type:layoutType} = requestParmas;


        return <WeaPortalLayout ecId={`${this && this.props && this.props.ecId || ''}_WeaPortalLayout@7rghrw`} id={id} isSetting={isSetting} layoutType={layoutType}/>;
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/components/PortalLayout.js